/**
 * What the game runs on a timetable, worked out from the clock alone (no Bungie request): the hourly Distortions, the
 * daily and weekly Rotations and Xûr's weekend. No imports, so the worker's page text (worker/pages.ts) uses it too.
 */

// ---------------- Distortions: a different destination every hour (Bungie's data does not say which) ----------------

const DISTORTIONS = ['Europa', 'Arcadian Valley', 'Cosmodrome', 'European Dead Zone', 'The Dreaming City', "Savathûn's Throne World", 'The Moon'];
const SEEN_HOUR = 497625, SEEN_INDEX = 1;   // the hour (since 1970, UTC) Arcadian Valley, the second, was seen to be on

export function distortionAt(hoursAhead: number): { name: string; starts: Date } {
  const hour = Math.floor(Date.now() / 3_600_000) + hoursAhead;
  const n = DISTORTIONS.length;
  return { name: DISTORTIONS[(((hour - SEEN_HOUR + SEEN_INDEX) % n) + n) % n], starts: new Date(hour * 3_600_000) };
}
export const minutesToNextDistortion = () => Math.floor((3_600_000 - (Date.now() % 3_600_000)) / 60_000);

// ---------------- Rotations: projected from the order the game has followed ----------------

// each: its name, weekly or daily, what it cycles through, which entry was on at the reset of Tuesday 6 October 2026
export const ROTATIONS: { name: string; weekly: boolean; cycle: string[]; at: number }[] = [
  { name: 'Exotic Mission', weekly: true, cycle: ['Encore', "Kell's Fall", 'Presage', 'Vox Obscura', "Operation: Seraph's Shield", '//node.ovrd.AVALON//', 'Starcrossed'], at: 4 },
  { name: 'The Wellspring', weekly: false, cycle: ['The Wellspring: Defend', 'The Wellspring: Attack'], at: 0 },
  { name: 'Lucent Executioners', weekly: false, cycle: ['Alluring Curtain Executioner', "Witch's Echo Executioner", "Queen's Bailey Executioner"], at: 2 },
  { name: 'Altars of Sorrow', weekly: false, cycle: ['Nightmare of Zydron, Gate Lord', 'Nightmare of Phogoth, the Untamed', 'Nightmare of Taniks, the Scarred'], at: 0 },
  { name: 'Ascendant Challenge', weekly: true, cycle: ['Ouroborea', 'Forfeit Shrine', 'Shattered Ruins', 'Keep of Honed Edges', 'Agonarch Abyss', 'Cimmerian Garrison'], at: 2 },
];
export const ROTATION_ANCHOR = Date.UTC(2026, 9, 6, 17, 0, 0);   // the game's day starts at 17:00 UTC; its week on Tuesday

/**
 * Whether Xûr is in the game now: Friday 17:00 UTC until the weekly reset, Tuesday 17:00 UTC. Bungie's vendor lists
 * (2026-10-24) keep him enabled with stock all week, so his being listed is no sign that he is here.
 * leaves: when he goes (while here); arrives: when he is next back (while away).
 */
export function xurWindow(now = new Date()): { here: boolean; leaves?: Date; arrives?: Date } {
  const DAY = 86_400_000;
  // the last Friday 17:00 UTC at or before now
  const sinceFri = (now.getUTCDay() - 5 + 7) % 7;
  let fri = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - sinceFri, 17);
  if (fri > now.getTime()) fri -= 7 * DAY;
  const tue = fri + 4 * DAY;
  return now.getTime() < tue ? { here: true, leaves: new Date(tue) } : { here: false, arrives: new Date(fri + 7 * DAY) };
}
